<template>
  <div>
    <AtomContainer>
      <Accordion>
        <AccordionItem v-for="item in list" :key="item.name" :item="item" class="-md:border-gray-100">
          <template slot="accordion-trigger">
            <AtomTitle
              tag="h1"
              as="h2"
              class-name="-md:flex"
              :sup="item.sup"
              class-name-sup="md:!text-base md:!top-2 -md:!left-2 md:!left-0 -md:leading-[130%] -md:!top-0"
              >{{ item.title }}</AtomTitle
            >
          </template>
          <template slot="accordion-content">
            <div class="lists">
              <div v-for="listItem in item.list" :key="listItem.name" class="w-full" @click="modalItem = listItem">
                <MoleculeListTitleImage :list="listItem" />
              </div>
            </div>
          </template>
        </AccordionItem>
      </Accordion>
    </AtomContainer>
    <Modal v-if="modalItem" :title="modalItem.label" :img="modalItem.image" @close="modalItem = null">
      <div class="flex flex-col gap-y-10 mb-10">
        <MoleculeModalRowButton v-for="item in modalItem.tags" :key="item.name" :item="item" />
      </div>
      <MoleculeModalRowText :item="modalItem.text" />
      <MoleculeModalRowProgress v-for="item in modalItem.progress" :key="item.title" :item="item" />
      <template #footer>
        <MoleculeModalRowButton v-for="item in modalItem.footer" :key="item.name" :item="item" />
      </template>
    </Modal>
  </div>
</template>

<script>
import Accordion from '../../../atoms/accordion/AtomAccordion'
import AccordionItem from '../../../atoms/accordion/AtomAccordionItem'
import AtomTitle from '../../../atoms/AtomTitle'
import AtomContainer from '../../../atoms/layouts/AtomContainer'
import MoleculeListTitleImage from '../../../molecules/layouts/MoleculeListTitleImage'
import MoleculeModalRowButton from '../../../molecules/modals/MoleculeModalRowButton'
import MoleculeModalRowProgress from '../../../molecules/modals/MoleculeModalRowProgress'
import MoleculeModalRowText from '../../../molecules/modals/MoleculeModalRowText'
import Modal from '../../../templates/layouts/Modal'

export default {
  name: 'OrganismAccordion',
  components: {
    MoleculeModalRowProgress,
    MoleculeModalRowButton,
    MoleculeModalRowText,
    AtomContainer,
    AtomTitle,
    Accordion,
    AccordionItem,
    MoleculeListTitleImage,
    Modal,
  },
  props: ['list'],
  data() {
    return {
      modalItem: null,
    }
  },
}
</script>

<style lang="postcss" scoped>
.lists {
  &:hover {
    .item {
      @apply md:text-gray-500;
    }
  }
}
</style>
